import { useFeatureFlagEnabled } from '@sunrun/sales-experience-shared/react-feature-flags';
import { FEATURE_FLAGS } from 'constants/FeatureFlags';
import {
  NewDashboardOrgType,
  getNewDashboardOrgType,
} from 'helpers/repTypeHelper';
import { useUserProfile } from 'providers/UserProfile';

const OPPTY_STAGE_COLUMN_ORG_TYPES: NewDashboardOrgType[] = [
  'CHAIN',
  'AIR',
  'BLOCK',
];

const useOpptyStageColumnsEnabled = (): boolean => {
  const { userProfile } = useUserProfile();
  const opptyStageColumnsFlagEnabled = useFeatureFlagEnabled(
    FEATURE_FLAGS.PIPELINE_V2_OPPTY_STAGE_COLUMNS,
  );
  const pipelineV2StylingEnabled = useFeatureFlagEnabled(
    FEATURE_FLAGS.PIPELINE_V2_STYLING,
  );

  return (
    Boolean(opptyStageColumnsFlagEnabled) &&
    Boolean(pipelineV2StylingEnabled) &&
    OPPTY_STAGE_COLUMN_ORG_TYPES.includes(getNewDashboardOrgType(userProfile))
  );
};

export { useOpptyStageColumnsEnabled };
